// extracted by mini-css-extract-plugin
export default {"card":"bY-z","carouselContainer":"cY-z","carouselContent":"dY-z"};